<template>
  <div>
    <div>
      <PayMethods/>
    </div>
    <div v-if="PayMethodSelected == 0">
      <stripeElements
        ref="elementsRef"
        pk="pk_test_CtKIbHHs6buI90ms8pw7IGaM00TkopKl5z"
        :amount="cost"
        @token="tokenCreated"
        @loading="loading = $event">
      </stripeElements>
    </div>  
    <!--<b-form @submit="processPayment">
      <div v-if="PayMethodSelected == 0">
        <b-form-group label="Número de tarjeta:" class="font-weight-bold" label-for="number">
          <div class="form-control d-flex h-auto shadow-sm">
            <span class="p-2">
              <h5 class="fas fa-credit-card m-0 font-gray-dark"></h5>
            </span>
            <b-form-input
              id="number"
              class="border-0"
              required
              v-model="creditcard.card.number"
              data-conekta="card[number]"
              v-mask="'#### #### #### ####'"
            ></b-form-input>
          </div>
        </b-form-group>
        <b-form-group label="Nombre y Apellido:" class="font-weight-bold" label-for="name">
          <div class="form-control d-flex h-auto shadow-sm">
            <span class="p-2">
              <h5 class="fas fa-user m-0 font-gray-dark"></h5>
            </span>
            <b-form-input
              id="name"
              class="border-0"
              required
              data-conekta="card[name]"
              v-model="creditcard.card.name"
            ></b-form-input>
          </div>
        </b-form-group>
        <b-form-group class="font-weight-bold" label="CVV" label-for="csv">
          <div class="form-control d-flex h-auto shadow-sm">
            <span class="p-2">
              <h5 class="fas fa-lock m-0 font-gray-dark"></h5>
            </span>
            <b-form-input
              placeholder="CVV"
              class="border-0"
              required
              v-mask="'###'"
              data-conekta="card[cvc]"
              v-model="creditcard.card.cvc"
            ></b-form-input>
          </div>
        </b-form-group>
        <b-form-group class="font-weight-bold" label="Fecha de expiración">
          <div class="form-control d-flex h-auto shadow-sm">
            <span class="p-2">
              <h5 class="fas fa-calendar-week m-0 font-gray-dark"></h5>
            </span>
            <b-form-input
              placeholder="AAAA"
              class="border-0 m-0"
              required
              v-mask="'####'"
              data-conekta="card[exp_year]"
              v-model="creditcard.card.exp_year"
            ></b-form-input>
            <span class="p-2">
              <h5 class="m-0 font-gray-dark">/</h5>
            </span>
            <b-form-input
              placeholder="MM"
              class="border-0 m-0"
              required
              v-mask="'##'"
              data-conekta="card[exp_month]"
              v-model="creditcard.card.exp_month"
            ></b-form-input>
          </div>
        </b-form-group>
      </div>-->


    <span class="text-danger">{{ errors }}</span>

    <b-row>
      <b-col>
        <div class="_protect font-green mb-2 mt-4">
          <i class="fas fa-lock"></i>
          Compra protegida
        </div>
      </b-col>
      <!-- <b-col>
        <div v-if="PayMethodSelected == 0" class="_protect font-dark mb-2 mt-4 float-right">
          <b-form-checkbox
            v-model="saveCard"
            :value="true"
            :unchecked-value="false"
          >Guardar para futuras compras
          </b-form-checkbox>
        </div>
      </b-col> -->
    </b-row>
    <b-button
      @click="submitPay"
      class="btn btn-block  btn-lg mt-4 shadow px-4 align-items-center" style="background:#ffba02; color:#244076;"
      :disabled="loadingPayment || PayMethodSelected == null"
    >
    <template v-if="valida == 'Si'">
      <b-spinner v-if="loadingPayment" small label="Espere ..." class="m-1"></b-spinner>
      {{ loadingPayment ? 'Procesando ...' : 'Pagar $ ' + cost + ' ' + currency }}
    </template>
    <template v-else>
      <b-spinner v-if="loadingPayment" small label="Espere ..." class="m-1"></b-spinner>
      {{ loadingPayment ? 'Procesando ...' : 'Gratis'}}
    </template>
    </b-button>
    <!-- <div class="d-flex mt-2 text-center w-100">
      <small class="mt-2 font-weight-bold text-black-50">
        Payment service powered by</small>
      <img height="15" class="mt-2 ml-1"
           src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/1200px-Stripe_Logo%2C_revised_2016.svg.png"
           alt="">
    </div> -->
  </div>
</template>
<script>
import PayMethods from "./PayMethods";
import stripeElements from "./stripe-elements"; 
import axios from 'axios'
export default {
  components: {
    PayMethods,
    stripeElements
  },
  props: {
    type: {
      type: String,
      default: "plan"
    },
    plan: {
      type: String, 
    },
    plan_id: {
      type: Number,
      default: null
    },
    course_id: {
      type: Number,
      default: null
    },
    billRequired: {
      type: Boolean,
      default: false,
    },
    billData: {
      type: Object,
      default: a => a,
    },
    cost: Number,
    pay_id: Number,
    currency: String,
    valida: String
  },
  data() {
    return {
      billDataValid: false,
      loadingPayment: false,
      PayMethodSelected: null,
      Method: null,
      typeCard: null,
      saveCard: false,
      errors: "",
      stripe: null,
    };
  }, 
  methods: {
    crearFactura(){
      const token = 'sk_test_b6X4Y5QELJjyzeKDAPo9jjQ986MP2ONa1pnmlR7vWV'; 

      const  headers = {  
              'Authorization': `Bearer ${token}` 
          }

      var objprueba = null;

      objprueba = {
            "payment_form": this.billData.pago,
            "use": this.billData.usoCfdi,
            "customer": {
              "legal_name": this.billData.razonSocial,
              "tax_id": this.billData.rfc,
              "tax_system": this.billData.regimen,
              "email": this.billData.email,
              "address": {
                "street": this.billData.domicilioFiscal,
                "zip":this.billData.codigo_postal,
                "country": "MEX",
                "interior":this.billData.numero_int,
                "exterior":this.billData.numero_ext
              }
            },
            "items": [
              { 
                "product": {
                  "description": this.plan,
                  "price": this.cost,
                  "product_key":"90111800",
                  "unit_key": "DAY"
                }
              }
            ]
          }
      axios.post('https://www.facturapi.io/v2/invoices',  objprueba, {
        headers: headers
      }).then( ({data}) => { 
            console.log(data);
            this.enviarFactura(data.id);
      }); 
    },
    enviarFactura(id){
      const token = 'sk_test_b6X4Y5QELJjyzeKDAPo9jjQ986MP2ONa1pnmlR7vWV'; 

      const  headers = {  
              'Authorization': `Bearer ${token}` 
          }

          var objprueba = null;

      axios.post('https://www.facturapi.io/v2/invoices/' + id + '/email',objprueba, {
        headers: headers
      }).then( ({data}) => { 
            console.log(data); 
      }); 
    },
    onSubmitPay(token) {

      this.loadingPayment = true;


      var paymentForm = null;

      if (this.type === "plan") {
        paymentForm = {
          invoiceRequired: this.billRequired,
          invoiceData: this.billData,
          methodExists: this.Method,
          type: "plan",
          saveCard: this.saveCard,
          idItem: this.plan_id,
          token: token,
        };
      } else if (this.type === "course") {
        paymentForm = {
          invoiceRequired: this.billRequired,
          invoiceData: this.billData,
          methodExists: this.Method,
          type: "course",
          saveCard: this.saveCard,
          idItem: this.course_id,
          token: token,
        };
      } else if (this.type === "candidates") {
        paymentForm = {
          invoiceRequired: this.billRequired,
          invoiceData: this.billData,
          methodExists: this.Method,
          type: "candidates",
          saveCard: this.saveCard,
          idItem: this.plan_id,
          token: token,
        };
      }

      this.api
        .post("payment/pay", JSON.stringify(paymentForm))
        .then(({data}) => {
          console.log(data);
          
          if (data.payment) {
            this.bus.$emit("payment_" + this.pay_id, data.payment);
          }
          if (this.billRequired == true)
          {
            this.crearFactura();
          }
          
 
        })
        .catch(err => {
          this.loadingPayment = false;
          if (err.response.status === 500) {
            console.log(err.response.data.errors);
            if (err.response.data.errors) {
              var errors = err.response.data.errors;
              if (errors.show) {
                this.errors = errors.message;
              } else {
                this.errors = "Lo sentimos. Su transacción no se pudo llevar a cabo.";
              }
            } else {
              this.errors = "Lo sentimos. Su transacción no se pudo llevar a cabo.";
            }
          }
        });
    },
    tokenCreated(token) {
      this.onSubmitPay(token)
    },
    validateFormInvoice() {
      return new Promise((resolve) => {
        this.bus.$on('validate_billdata_resp',
          (billDataValid) => {
            this.billDataValid = billDataValid
            resolve(billDataValid)
          });
        this.bus.$emit('validate_billdata');
      })
    },
    async submitPay() {

      if (this.billRequired) {
        await this.validateFormInvoice()
        if (!this.billDataValid) {
          this.errors = "Por favor llena todos tus datos fiscales"
          return false;
        }
      }

      this.errors = null;

      if (!this.Method) {
        this.bus.$emit('submit_pay', true);
      } else {
        this.onSubmitPay(null)

      }

    }
  }
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/#public/payments/CreditCard.vue